/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import { useTrackingContext } from "../../analytics";
import { BlockDetailsCard, Header } from "../../components";
import { TRACKING_CONTEXT } from "../../constants";
import { trackProcess, trackView } from "../../helpers";
import { IFlexOneCard } from "../../interfaces";

const FlexOneCard: React.FC<IFlexOneCard> = (props: IFlexOneCard) => {
  const {
    headerInfo: { heading, subHeading },
    cardInfo,
  } = props;
  const track = useTrackingContext();

  useEffect(() => {
    trackView(track, TRACKING_CONTEXT.PAGE.NULL, `${cardInfo.customerNumber}`);
    trackProcess(
      track,
      TRACKING_CONTEXT.PAGE.NULL,
      TRACKING_CONTEXT.ACCOUNT_TYPE.VALUE.FLEX_ONE,
      TRACKING_CONTEXT.INVESTOR_TYPE.VALUE.SOLE
    );
  }, [cardInfo]);

  return (
    <>
      <Header heading={heading} subHeading={subHeading} />
      <BlockDetailsCard {...cardInfo} />
    </>
  );
};

export default FlexOneCard;
